import { createSelector } from 'reselect'

const getStore = (state) => state
const getProps = (state, props) => props
const getSavePoint = (state) => {
  return state.savePoint
}

export const getStatusFromConditions = createSelector(
  [getSavePoint, getProps, getStore],
  (savePoint, props, store) => {
    let actualObject = savePoint.elementsStatuses[props.id]
    let actualStatus = actualObject
      ? actualObject
      : props.status
      ? props.status
      : props.initialStatus
    if (!actualStatus) {
      actualStatus = 'default'
    }

    let nextStatuses =
      props.statusInfo &&
      props.statusInfo[actualStatus] &&
      props.statusInfo[actualStatus].nextStatuses
    let newStatus = actualObject ? false : actualStatus
    if (nextStatuses) {
      nextStatuses.forEach((nameStatus) => {
        let allConditionsTrue = evaluateAll(props.statusInfo[nameStatus].conditions, store)
        if (allConditionsTrue) {
          newStatus = nameStatus
        }
      })
    }
    return newStatus ? newStatus : actualStatus
  }
)

const evaluateCond = (condition, store) => {
  let storeElement = byString(store, condition.storeKey)
  let elem =
    storeElement && condition.searchKey
      ? storeElement.find((item) => item[condition.searchKey] === condition.searchValue)
      : storeElement

  let evaluate
  if (elem && condition.operator) {
    if (condition.operator === 'includes') {
      evaluate = elem.indexOf(condition.value) > -1
    } else if (condition.operator === '!includes') {
      evaluate = elem.indexOf(condition.value) === -1
    } else {
      // Safe operator evaluation without eval
      const stringElem = String(elem)
      const stringValue = String(condition.value)
      
      switch (condition.operator) {
        case '==':
          evaluate = stringElem === stringValue
          break
        case '!=':
          evaluate = stringElem !== stringValue
          break
        case '>':
          evaluate = parseFloat(elem) > parseFloat(condition.value)
          break
        case '<':
          evaluate = parseFloat(elem) < parseFloat(condition.value)
          break
        case '>=':
          evaluate = parseFloat(elem) >= parseFloat(condition.value)
          break
        case '<=':
          evaluate = parseFloat(elem) <= parseFloat(condition.value)
          break
        default:
          console.warn(`Unsupported operator: ${condition.operator}`)
          evaluate = false
      }
    }
  } else if (condition.storeKey.indexOf('currentGoal') > -1) {
    evaluate =
      condition.operator === '!includes'
        ? false
        : condition.operator.indexOf('includes') > -1
        ? true
        : elem
  } else if (!elem && !process.env.OLD_EVALUATE) {
    // Safe evaluation for empty elements
    const stringElem = String(elem)
    const stringValue = String(condition.value)
    
    switch (condition.operator) {
      case '==':
        evaluate = stringElem === stringValue
        break
      case '!=':
        evaluate = stringElem !== stringValue
        break
      default:
        evaluate = false
    }
  }
  return evaluate
}

/**
* Check if conditions are true or false.
*** Each condition should be represented as an object with some fields (some optionals)
      {
        storeKey: 'savepoint...',
        operator: '> < >= ...',
        value: 'the value...'
        searchKey: 'if storeKey is an array we can get the element with a searchKey and search value'
        searchValue: 'the value for the storekey'
      }
*** All conditions objects in one array imply 'AND' and all of them should be TRUE to confirm the evaluation
      i.e.:   conditions: [{~c1~},{~c2~},{~c3~}]  the evaluation is true only if c1 c2 c3 are true
*** We wrap conditions in other array if we want make OR condition
      i.e.:   conditions: [ [{~c1~},{~c2~}], [{~c3~}] ] The evaluation is true if c1 and c2 are true OR c3 is true
//TODO:AC -> Optimize recursive evaluation
*/
export const evaluateAll = (conditions, store) => {
  if (!conditions) {
    return false
  }

  let conds = []
  let or = false
  for (let c of conditions) {
    if (Array.isArray(c)) {
      or = true
      let allTrue = evaluateAll(c, store) //recursive OP
      conds.push(allTrue)
      if (allTrue) {
        return true
      }
    } else {
      let isTrue = evaluateCond(c, store)
      conds.push(isTrue)
      if (!isTrue) {
        return false
      }
    }
  }
  return or ? conds.some(allTrue) : conds.every(allTrue)
}

const allTrue = (e) => e !== false && e !== undefined && e !== null && e !== 0
export const byString = function (obj, str) {
  str = str.replace(/\[(\w+)\]/g, '.$1') // convert indexes to properties
  str = str.replace(/^\./, '') // strip a leading dot
  var arr = str.split('.')
  for (var i = 0, n = arr.length; i < n; ++i) {
    var k = arr[i]
    if (k in obj) {
      obj = obj[k]
    } else {
      return
    }
  }
  return obj
}
